import { isAxiosError } from "axios";
import { showConnectionError } from "../../promptMessages/PromptMessages";
import { ALERTMSG } from "../enums";

export const FetchErr = (
  error: any,
  themeBackground: string,
  customColor: string | undefined,
  themeTextColor: string
) => {
  if (isAxiosError(error)) {
    const status =
      error.response?.status ||
      error.request?.status ||
      error.code ||
      "UNKNOWN_AXIOS_ERROR";
    showConnectionError(
      ALERTMSG.SERVDISRUPTION,
      `(code ${status})`,
      "error",
      themeBackground,
      customColor,
      themeTextColor
    );
  } else {
    const status =
      error?.response?.status ||
      error?.code ||
      error?.message ||
      "UNKNOWN_ERROR";
    showConnectionError(
      ALERTMSG.UNDHANDLEDERR,
      `(code ${status})`,
      "error",
      themeBackground,
      customColor,
      themeTextColor
    );
  }
};
